module.exports = __webpack_public_path__ + "static/media/protocol.5737bcfe.htm";